export default __webpack_public_path__ + "static/WorkSans-Medium-5631a8d6a51c16cdf7e3fe4f3c58fbf2.woff";